import React from "react";
import { motion } from "framer-motion";
import SafeIcon from "../common/SafeIcon";
import * as FiIcons from "react-icons/fi";

const { FiCreditCard, FiUsers, FiBriefcase, FiDollarSign } = FiIcons;

const Financement = () => {
  const options = [
    {
      title: "CPF",
      subtitle: "Compte Personnel de Formation",
      description: "Utilisez vos droits CPF pour financer votre formation",
      icon: FiCreditCard,
      color: "bg-blue-100 text-blue-600",
    },
    {
      title: "France Travail",
      subtitle: "Pôle Emploi",
      description: "Aide au financement pour les demandeurs d'emploi",
      icon: FiUsers,
      color: "bg-green-100 text-green-600",
    },
    {
      title: "OPCO / FAF",
      subtitle: "Organismes paritaires",
      description:
        "Financement par votre organisme de formation professionnelle",
      icon: FiBriefcase,
      color: "bg-purple-100 text-purple-600",
    },
    {
      title: "Financement personnel",
      subtitle: "Paiement direct",
      description: "Possibilité d'échelonnement des paiements",
      icon: FiDollarSign,
      color: "bg-orange-100 text-orange-600",
    },
  ];

  const tarifs = [
    {
      formation: "Accompagnement VAE",
      prix: "2 800€",
      description: "Frais de certification et examen inclus",
    },
    {
      formation: "Université d'été",
      prix: "3 200€",
      description: "Formation intensive 102h",
    },
    {
      formation: "Pack Expert (VAE + Éloquence)",
      prix: "4 000€",
      description: "2 certifications et examens inclus",
    },
    {
      formation: "Sessions Longues",
      prix: "4 500€",
      description: "Formation complète 144h (Sept. / Janv.)",
    },
  ];

  return (
    <section id="financement" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Financement et tarifs
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez nos solutions de financement. Nos formations sont 100%
            finançables dans la limite de vos droits disponibles.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3 className="text-3xl font-bold text-gray-900 mb-8">
              Options de financement
            </h3>
            <div className="space-y-6">
              {options.map((option, index) => (
                <motion.div
                  key={index}
                  className="bg-gray-50 p-6 rounded-xl hover:shadow-lg transition-shadow duration-300"
                >
                  <div className="flex items-start space-x-4">
                    <div className={`p-3 rounded-lg ${option.color}`}>
                      <SafeIcon icon={option.icon} className="h-6 w-6" />
                    </div>
                    <div className="flex-1">
                      <h4 className="text-xl font-semibold text-gray-900 mb-1">
                        {option.title}
                      </h4>
                      <p className="text-blue-600 font-medium mb-2">
                        {option.subtitle}
                      </p>
                      <p className="text-gray-600">{option.description}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3 className="text-3xl font-bold text-gray-900 mb-8">
              Grille tarifaire
            </h3>
            <div className="space-y-4">
              {tarifs.map((tarif, index) => (
                <motion.div
                  key={index}
                  className="bg-white border-2 border-gray-200 p-6 rounded-xl hover:border-blue-300 transition-colors duration-300"
                >
                  <div className="flex justify-between items-start mb-3">
                    <h4 className="text-lg font-semibold text-gray-900">
                      {tarif.formation}
                    </h4>
                    <span className="text-xl font-bold text-blue-600">
                      À partir de {tarif.prix}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600">{tarif.description}</p>
                </motion.div>
              ))}
            </div>

            <div className="mt-8 p-6 bg-gradient-to-r from-green-50 to-blue-50 rounded-xl border border-green-200">
              <h4 className="font-semibold text-gray-900 mb-2">
                Conseil Financement
              </h4>
              <p className="text-gray-600 text-sm">
                Étude personnalisée de votre dossier : CPF / France Travail /
                OPCO / FAF et personnel.
              </p>
              <div className="mt-4 text-center">
                <p className="text-2xl font-bold text-gray-900">
                  01 83 79 02 87
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Financement;
